export function getSLColours() {
    const DISTINCT = [
      "#4e79a7", "#f28e2b", "#e15759", "#76b7b2", "#59a14f",
      "#edc948", "#b07aa1", "#ff9da7", "#9c755f", "#bab0ab"
    ];
    return DISTINCT;
  }
  
  export function getSLConfig() {
    const groupsById = {
  
      // maga_heir: {
      //   type: "categorical",
      //   label: "Heir MAGA",
      //   fulltext: "How concerned are you about potential cuts to the Affordable Care Act?",
      //   keys: [
      //     "maga_heir_donjr_pred",
      //     "maga_heir_notsure_pred",
      //     "maga_heir_vance_pred"
      //   ],
      //   labels: {
      //     "maga_heir_donjr_pred": "Donald Trump Jr.",
      //     "maga_heir_notsure_pred":  "Not sure",
      //     "maga_heir_vance_pred": "JD Vance",
      //   },
      //   colors:{
      //     "maga_heir_donjr_pred": "#BA0000",
      //     "maga_heir_notsure_pred":  "Not sure",
      //     "maga_heir_vance_pred": "#FAA2A2",
      //   }
      // },
     
      // === HEALTHCARE TRUST ===
      healthcare_trust: {
        type: "likert",
        label: "Trust in healthcare system",
        fulltext: "How much do you trust or distrust the U.S. healthcare system overall?",
        keys: [
          "healthcare_trust_pred",
          "healthcare_trust_neither_pred",
          "healthcare_distrust_pred",
        ],
        labels: {
          "healthcare_trust_pred": "Trust",
          "healthcare_trust_neither_pred": "Neither / neutral",
          "healthcare_distrust_pred": "Distrust",
        },
        polarity: {
          pos: "healthcare_trust_pred",
          neu: "healthcare_trust_neither_pred",
          neg: "healthcare_distrust_pred",
        },
        
      schema:"single",
      },
      healthcare_reform: {
        type: "likert",
        label: "View of U.S. healthcare system reform",
        fulltext: "How well do you think the U.S. healthcare system is currently working, or does it need reform?",
        keys: [
          "healthcare_reform_pred",
          "healthcare_minor_pred",
          "healthcare_dk_pred",
          "healthcare_well_pred",
        ],
        labels: {
          "healthcare_reform_pred": "Needs major reform",
          "healthcare_minor_pred": "Needs minor reform",
          "healthcare_dk_pred": "Don’t know / unsure",
          "healthcare_well_pred": "Working well as is",
        },
        polarity: {

            pos: "healthcare_well_pred",
            neu: "healthcare_minor_pred",
            neg: "healthcare_reform_pred"
            },
      schema:"single",

      },

      trust_institutions: {
        type: "categorical",
        label: "Trust in institutions",
        fulltext: "How much trust do you have in each of the following institutions when it comes to healthcare issues?",
        keys: [
          "trust_docs_pred",
          "trust_hospitals_pred",
          "trust_stategov_pred",
          "trust_fedgov_pred",
          "trust_pharmaorgs_pred",
          "trust_healthInsurance_pred",
          "trust_none_pred",
         // "trust_dk_pred",
        ],
        labels: {
          "trust_docs_pred": "Doctors",
          "trust_hospitals_pred": "Hospitals",
          "trust_stategov_pred": "State government",
          "trust_fedgov_pred": "Federal government",
          "trust_pharmaorgs_pred": "Pharmaceutical companies",
          "trust_healthInsurance_pred": "Health insurance companies",
          "trust_none_pred": "None of these",
         // "trust_dk_pred": "Don’t know",
        },
      schema:"single",
      },


  
    };

    
  
    return { groupsById };
}

// Tab-as-config default export
export default {
  tab: "stateleg",
  label: "State Legislature",
  get metrics() { return getSLConfig().groupsById; },
};


